export const RESET = "reset";
export const UPDATE_ACCESS_TOKEN = "setAccessToken";
export const CLEAN_ACCESS_TOKEN = "cleanAccessToken";
export const UPDATE_USER = "setUser";
export const CLEAN_USER = "cleanUser";
export const UPDATE_USER_ROLE = "updateUserRole";
export const UPDATE_IS_RECONNECTING = "updateIsReconnecting";
export const UPDATE_CONNECTION_STATE = "updateConnectionState";
